import { Bell } from "lucide-react";
import { formatNotifTime } from "../../utils/formatters";

const NotificationsDropdown = ({
  notificationsOpen,
  setNotificationsOpen,
  notifications,
  unreadNotifications,
  readNotifIds,
  onMarkNotificationRead,
  onNavigate
}) => {
  return (
    <div className="relative">
      <button 
        className="p-2 text-[#A1A1AA] hover:text-white transition-colors relative"
        onClick={() => setNotificationsOpen(!notificationsOpen)}
      >
        <Bell size={20} />
        {unreadNotifications > 0 && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#F87171] rounded-full text-white text-xs flex items-center justify-center">
            {unreadNotifications}
          </span>
        )}
      </button>
      
      {notificationsOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setNotificationsOpen(false)}
          />
          <div className="absolute right-0 top-full mt-2 w-80 bg-[#0A0A0C] border border-[#1F1F1F] rounded-lg shadow-xl z-50 max-h-96 overflow-hidden">
            <div className="p-3 border-b border-[#1F1F1F] flex justify-between items-center">
              <span className="font-semibold text-white">Уведомления</span>
              {unreadNotifications > 0 && (
                <span className="text-xs text-[#EDEDED]">{unreadNotifications} новых</span>
              )}
            </div>
            <div className="max-h-72 overflow-y-auto">
              {notifications.length === 0 ? (
                <div className="p-4 text-center text-[#A1A1AA] text-sm">
                  Нет уведомлений
                </div>
              ) : (
                notifications.slice(0, 5).map((notif) => {
                  const isRead = readNotifIds.has(notif.id);
                  return (
                    <div
                      key={notif.id}
                      onClick={() => {
                        if (!isRead) onMarkNotificationRead(notif.id);
                      }}
                      className={`p-3 border-b border-[#1F1F1F]/50 cursor-pointer transition-colors ${
                        isRead ? 'opacity-60' : 'hover:bg-[#1A1A1A]'
                      }`}
                    >
                      <div className="flex items-start gap-2">
                        {!isRead && (
                          <span className="w-2 h-2 bg-white rounded-full mt-1.5 flex-shrink-0"></span>
                        )}
                        <div className="flex-1 min-w-0">
                          <div className="flex justify-between items-start gap-2">
                            <span className="font-medium text-white text-sm truncate">{notif.title}</span>
                            <span className="text-[#A1A1AA] text-xs whitespace-nowrap">{formatNotifTime(notif.created_at)}</span>
                          </div>
                          <p className="text-[#A1A1AA] text-xs mt-0.5 line-clamp-2">{notif.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            {notifications.length > 5 && (
              <div className="p-2 border-t border-[#1F1F1F]">
                <button
                  onClick={() => {
                    setNotificationsOpen(false);
                    onNavigate('/notifications');
                  }}
                  className="w-full text-center text-[#EDEDED] hover:text-[#EDEDED] text-sm py-1"
                >
                  Показать все
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationsDropdown;
